export default "__VITE_ASSET__3UJKtw8S__"